interface MFModule {
  [module: string]: {
    name: string;
    entry: {
      local: string;
      dev: string;
      qa: string;
      beta: string;
      prod: string;
    };
    modules: string[];
  };
}

export const MF_MODULES: MFModule = {
  widgets: {
    name: 'widgets',
    entry: {
      local: 'http://localhost:8081/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/widgets/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/widgets/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/widgets/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/widgets/prod/v0.0.1/remoteEntry.js',
    },
    modules: ['./TestWidget', './MarketingEmailBanner'],
  },
  home: {
    name: 'home',
    entry: {
      local: 'http://localhost:8082/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/home/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/home/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/home/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/home/prod/v1.1.1/remoteEntry.js',
    },
    modules: ['./Home', './ThumbnailCard'],
  },
  playground: {
    name: 'playground',
    entry: {
      local: 'http://localhost:8080/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/playground/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/playground/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/playground/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/playground/prod/v0.0.1/remoteEntry.js',
    },
    modules: ['./Playground', './EventModal'],
  },
  SafetyEvents: {
    name: 'SafetyEvents',
    entry: {
      local: 'http://localhost:8085/remoteEntry.js',
      dev: 'https://assets.lightmetrics.co/mf/SafetyEvents/dev/latest/remoteEntry.js',
      qa: 'https://assets.lightmetrics.co/mf/SafetyEvents/qa/latest/remoteEntry.js',
      beta: 'https://assets.lightmetrics.co/mf/SafetyEvents/beta/latest/remoteEntry.js',
      prod: 'https://assets.lightmetrics.co/mf/SafetyEvents/prod/v0.0.1/remoteEntry.js',
    },
    modules: ['./SafetyEvents', './DateComponent', './TagComponent'],
  },
};
